module.exports = __webpack_public_path__ + "static/media/all_legislation.f9eb1bd3.svg";